import React from "react";

interface Props {
  children: React.ReactNode;
}

export const PreviewText: React.FC<Props> = (props) => {
  const { children } = props;

  return <div className="preview__text">{children}</div>;
};
